import dynamic from 'next/dynamic';

const ICON_ALIASES = {
  "auto-condo-policy": "Bundle",
  "auto-home-policy": "Bundle",
  "auto-renters-policy": "Bundle",
  "auto": "Auto",
  "billingPayment": "BillingPayment",
  "bundleMultiPolicy": "Bundle",
  "burglar": "Burglar",
  "clock": "Clock",
  "condo": "Condo",
  "home": "Home",
  "life": "Life",
  "motorcycle": "Motorcycle",
  "pet": "Pet",
  "renters": "Renters",
  "savingsDiscount": "SavingsDiscount",
};
const ICON_NAMES = [
  ...Object.keys(ICON_ALIASES),
  "12MonthGuarantee",
  "24HrClaims",
  "24HrEmergencyRepair",
  "24HrRoadsideAssistance",
  "AboutMe",
  "AccordionCaretUp",
  "AccidentForgiveness",
  "Add",
  "AddItem",
  "AddItemBreak",
  "AdaptiveCC",
  "AdaptiveHeadlights",
  "Agent",
  "Analysis",
  "AntiqueCar",
  "ATV",
  "Attachments",
  "Auto",
  "Auto3rdPartyLiability",
  "AutoCondo",
  "AutoDamage",
  "AutoGlassDamage",
  "AutoHome",
  "AutoID",
  "AutoRenters",
  "AutomaticDisabling",
  "AutonomousBraking",
  "Autopay",
  "Backhoe",
  "BarkingDog",
  "Bell",
  "BetterBikeReplacement",
  "BetterCarReplacement",
  "BillingPayment",
  "BlindSpotWarning",
  "BodilyInjury",
  "BoatAccessories",
  "BoatEmergency",
  "Bookmark",
  "Broken",
  "BrokenLink",
  "BrokenLinkCircle",
  "Burglar",
  "Bundle",
  "Business",
  "BusinessOwnersPolicy",
  "Calculator",
  "CalendarLrg",
  "CalendarSm",
  "Camera",
  "CaretCircleLeft",
  "CaretCircleRight",
  "CaretDown",
  "CaretLeft",
  "CaretRight",
  "CaretUp",
  "CateringServices",
  "Chat",
  "Check",
  "Checkbook",
  "Checklist",
  "Checkmark",
  "Claims",
  "ClaimsValet",
  "Clock",
  "Close",
  "CloseCircle",
  "Clothing",
  "Collision",
  "CollisionAvoidance",
  "CommercialAuto",
  "Compass",
  "ComputerMouse",
  "ComputerPhone",
  "Condo",
  "Contact",
  "Contractor",
  "Coverages",
  "CoverageCheck",
  "CoverageCustomizer",
  "CreditCard",
  "CustomerBrochure",
  "CustomerService",
  "Cyber",
  "DeathBenefit",
  "Deductible",
  "DeductibleFund",
  "DaytimeLights",
  "Desktop",
  "DesktopSoftware",
  "Document",
  "DocumentEFT",
  "DocumentExcel",
  "DocumentLifetimeRepair",
  "DocumentMulti",
  "DocumentPDF",
  "DocumentQuote",
  "DocumentSecure",
  "DocumentTimeSensitive",
  "DocumentWord",
  "Dollar",
  "Download",
  "DriverAlertness",
  "Duplicate",
  "Earthquake",
  "Edit",
  "ElectronicStability",
  "Email",
  "EngineTrouble",
  "EnvelopeMail",
  "ErrorAlert",
  "Esign",
  "Express",
  "Facebook",
  "Farm",
  "FineArt",
  "FindAgent",
  "Fire",
  "Flood",
  "Folder",
  "FontSize",
  "Fullscreen",
  "FuneralBenefits",
  "Gauge",
  "Garage",
  "GeneralLiability",
  "GolfCart",
  "Graph",
  "GuaranteedAutoRepair",
  "Hail",
  "Handshake",
  "Help",
  "Highrise",
  "Home",
  "HomeInspection",
  "HomePhysicalDamage",
  "Homepage",
  "HomeProtectorPlus",
  "HomeWarranty",
  "Hurricane",
  "ID",
  "InflationProtection",
  "Info",
  "InlandMarine",
  "Instagram",
  "LaneDepartureWarning",
  "Landlord",
  "Laptop",
  "LegalClaim",
  "Life",
  "LifetimeRepairGuarantee",
  "Lightning",
  "Linkedin",
  "LinkCaretLeft",
  "LinkCaretRight",
  "ListBullet",
  "LockClosed",
  "LockOpen",
  "Location",
  "LogIn",
  "LossofIncome",
  "LossofUse",
  "Lowrise",
  "Manufacturing",
  "ManualDisabling",
  "Medical",
  "MedicalExpenses",
  "MedicalMalpractice",
  "MedicalPayments",
  "Megaphone",
  "Menu",
  "MobileHome",
  "Motorcycle",
  "MotorcycleAccessories",
  "MotorcycleReplacement",
  "Multichannel",
  "Multicar",
  "Multidevice",
  "MyAccount",
  "New",
  "NewCarReplacement",
  "NightVision",
  "Notification",
  "Offsite",
  "Onstar",
  "OriginalParts",
  "OtherStructure",
  "Package",
  "Paperless",
  "PartlySunny",
  "PassiveRestraint",
  "Pen",
  "Pet",
  "People",
  "PersonalComputerReplacement",
  "PersonalProperty",
  "Phone",
  "PhotoGallery",
  "Policy",
  "PowerOn",
  "PriceTag",
  "Printer",
  "ProfessionalServices",
  "Property",
  "PropertyDamageLiability",
  "ProofofInsurance",
  "QuestionCircle",
  "QuestionMark",
  "Rain",
  "RearviewCamera",
  "Reinsurance",
  "RentalCarReimbursement",
  "Renters",
  "Retention",
  "RightTrack",
  "RightTrackReturn",
  "RV",
  "SafetyInfo",
  "SafeHomeowners",
  "SavingsBadge",
  "SavingsDiscount",
  "Search",
  "SeeMore",
  "SevereStorm",
  "Share",
  "ShoppingCart",
  "SignDoc",
  "SingleFamily",
  "SmallBusinessInsurance",
  "SmartMoney",
  "Smartphone",
  "Snow",
  "Snowmobile",
  "Sorting",
  "Specialist",
  "SpecialtyInsurance",
  "Star",
  "SteeringWheelLock",
  "Stopwatch",
  "SuccessAlert",
  "Sunny",
  "Tablet",
  "TextAlerts",
  "ThumbsDown",
  "ThumbsUp",
  "Time",
  "Tornado",
  "Townhouse",
  "Trash",
  "Tuition",
  "Twitter",
  "Umbrella",
  "Uninsured",
  "Upload",
  "Valuables",
  "VehicleRecovery",
  "VehicleTheft",
  "Video",
  "Warning",
  "Watercraft",
  "Wifi",
  "Windy",
  "Wholesale",
  "WorkersComp",
  "Youtube",
];

function getDynamicIcon(iconKey) {
  return dynamic(
    () => import(`@lmig/lmds-react/icons/${ICON_ALIASES[iconKey] || iconKey}`),
    {
      ssr: false,
    },
  );
}

export { getDynamicIcon, ICON_NAMES };
